import { getSingleParam } from 'x1-base/utils';
import { useTrackingUtils } from '~/composables';
import { useKookies } from 'x1-base/composables';
import type { PublicRuntimeConfig } from 'nuxt/schema';

type ShareASaleConfig = PublicRuntimeConfig['environment']['tracking']['shareASale'];

const shareASaleConfigObj = ref<Nullable<ShareASaleConfig>>(null);

export function useShareASale() {
    const useTrackingUtilsObj = useTrackingUtils();
    const { setKookie, getKookie } = useKookies();

    function init(): void {
        const route = useRoute();

        getConfig();

        if (!shareASaleConfigObj.value?.enabled) {
            return;
        }

        const { queryParamName, cookieName } = shareASaleConfigObj.value;

        if (!queryParamName || !cookieName) {
            return;
        }

        const cookieValue = getSingleParam(route.query, queryParamName);

        if (!cookieValue) {
            console.warn('SHARE A SALE: No code found');
            return;
        }

        const expires = new Date();
        expires.setTime(expires.getTime() + 94670778e4);

        setKookie(cookieName, cookieValue, { expires }, '');
    }

    function invoke(tracking: string, amount: number): void {
        getConfig();

        if (!shareASaleConfigObj.value?.enabled) {
            return;
        }

        const { merchantID, cookieName } = shareASaleConfigObj.value;

        if (!merchantID || !cookieName) {
            return;
        }

        const sscid = getKookie(cookieName, '');

        if (!sscid) {
            console.warn('SHARE A SALE: No cookie found');
            return;
        }

        const pixel = makePixelUrl({ tracking, amount: `${amount}`, sscid, merchantID });

        if (!pixel) {
            return;
        }

        useTrackingUtilsObj.appendTrackingPixel(pixel);
    }

    function getConfig(): void {
        const $config = useRuntimeConfig();
        const config = $config.public?.environment?.tracking?.shareASale;
        shareASaleConfigObj.value = shareASaleConfigObj.value || config || null;

        if (!shareASaleConfigObj.value?.enabled) {
            console.warn('Share A Sale is either not enabled or not configured');
            return;
        }
    }

    function makePixelUrl(params: Record<string, string>): Undefinable<string> {
        if (!shareASaleConfigObj.value?.pixelUrlBase) {
            return;
        }

        const { pixelUrlBase } = shareASaleConfigObj.value;

        try {
            const url = new URL(pixelUrlBase);
            url.search = (new URLSearchParams(params)).toString();
            return url.toString();
        } catch (error) {
            return pixelUrlBase;
        }
    }

    return {
        init,
        invoke
    };
}

